// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ScrollOptimizer from './ScrollOptimizer';
import { startCacheWatcher } from './utils/cacheBuster';

// 👇 Start cache watcher BEFORE rendering
// This runs automatically for every user and detects new deploys
startCacheWatcher();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ScrollOptimizer />
    <App />
  </React.StrictMode>
);

/*
 * NOTE on visitor analytics:
 * ─────────────────────────────────────────────────────────────
 * 1) PAGE VIEW TRACKING is done on the BACKEND (server.js middleware).
 *    Every GET request to a SPA route or /backend/api/* is logged to
 *    the `site_visits` table automatically — no client code needed.
 *
 * 2) ACTIVE-NOW HEARTBEAT is done by `useAnalyticsPing()` inside
 *    src/App.js, which POSTs to /backend/api/analytics-ping every
 *    2 minutes. It feeds the `site_sessions` table, so the Manager
 *    Dashboard can show "active in last 5 minutes".
 *
 * 3) Nothing else to add here. Rebuild the app after deploying:
 *      npm run build
 *    Then restart Node so the backend middleware starts logging.
 * ─────────────────────────────────────────────────────────────
 */